export default {
  'title': '網址設定',
  'type': 'object',
  'required': [
    'hostname', 'mode',
  ],
  'properties': {
    'hostname': {
      'type': 'string',
      'title': '網址',
      'description': '範例：demo.silvergatedelivery.com',
    },
    'mode': {
      'type': 'string',
      'title': '模式',
      'enum': ['app', 'groupPurchase', 'individualPurchase'],
      'enumNames': ['系統後台', '團購', '自費戶訂購'],
      'default': 'app',
    },
    'clientId': {
      'type': ['string', 'null'],
      'title': '指定機構',
      'description': '如果有指定機構，該網址只能下單該機構商品',
    },
    'name': {
      'type': ['string', 'null'],
      'title': '機構名稱',
    },
    'shortName': {
      'type': ['string', 'null'],
      'title': '機構簡稱',
    },
    'isOfficialVersion': {
      'type': ['boolean', 'null'],
      'title': '正式版本',
      'default': false,
      'description': '有些測試功能不會出現在正式版本，測試版本有些位置會顯示測試版本字樣',
    },
    'lineLoginEnabled': {
      'type': ['boolean', 'null'],
      'title': 'LINE登入',
      'default': false,
    },
    'liffId': {
      'type': ['string', 'null'],
      'title': 'LIFF ID',
    },
  },
};
